<div class="flex-container">
  <app-strategy-topics [is3aPillar]="true" *ngIf="tabSelected === 1"></app-strategy-topics>
  <app-strategy-3a-risk *ngIf="tabSelected === 2 || tabSelected === 3"></app-strategy-3a-risk>
  <app-strategy-personalise *ngIf="tabSelected === 4" [is3aPillar]="true"></app-strategy-personalise>
  <app-strategy-3a-portfolio *ngIf="tabSelected === 5" [step]="step"></app-strategy-3a-portfolio>
</div>
